import { Box, Skeleton } from "@mui/material";
import React from "react";

const LoadingSkeleton: React.FC = () => {
  const skeletonRows = Array.from({ length: 5 }, (_, index) => `row-${index}`);

  return (
    <Box sx={{ p: 2 }}>
      <Box
        sx={{ display: "grid", gridTemplateColumns: "1fr auto", gap: 2, mb: 3 }}
      >
        <Skeleton variant="rectangular" height={40} />
        <Skeleton variant="rectangular" width={140} height={40} />
      </Box>
      <Box>
        {skeletonRows.map((key) => (
          <Box
            key={key}
            sx={{
              display: "grid",
              gridTemplateColumns: "repeat(6, minmax(80px, 1fr))",
              gap: 2,
              py: 2,
            }}
          >
            <Skeleton height={20} />
            <Skeleton height={20} />
            <Skeleton height={20} />
            <Skeleton height={20} />
            <Skeleton height={20} />
            <Skeleton height={20} />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default LoadingSkeleton;
